/* 
  shanghaiqingqun：上海专用；
  平台兼容模块：使用本文件，将全国平台设置为省级平台；
  设置默认 provinceCode: defaultProvinceCode;
  提供

 */
import regions from '@/utils/regions'

export default {
  data() {
    return {
      defaultProvinceCode: '31',
      defaultProvinceName: '上海市', 
      current_city_code: "",   
    }
  },

  computed: {
    // 上海city列表：用于下拉选择表单组件的option选项；（可全局搜索select_city_list查看使用案例）
    select_city_list() {
      let arr = [];
      regions.forEach(item => {
        if(item.code === this.defaultProvinceCode) {
          arr = item.city;
        }
      })
      return arr;
    },

    // 根据 current_city_code 城市code获取区县列表；同select_city_list的使用方法；
    // current_city_code在city下拉选择框的change事件中设置；
    select_county_list() {
      let arr = [];
      if(this.current_city_code) {
        this.select_city_list.forEach(item => {
          if(item.code === this.current_city_code) {
            arr = item.county;
          }
        })
      }
      return arr;
    },

    // 同 select_city_list
    sh_county_list() {
      let arr = [];
      regions.forEach(item => {
        if(item.code === '31') {
          const { county, name } = item.city[0];
          arr = county
        }
      })
      return arr
    },

    current_county_name() {

    },
  },

  created() {
    // 特别注意；如果仅仅使用 select_city_list 等列表数据，在 导入本模块的时候，建议在目标文件中
    // 声明一个同名方法 ： setSelevtProvinceValue；用以覆盖本方法；具体操作可以全局匹配 setSelevtProvinceValue；查看使用案例
    this.setSelevtProvinceValue();
  },

  mounted() {
    // console.log('select_city_list', this.select_city_list)
    // console.log('select_county_list', this.select_county_list)
    // console.log('sh_county_list', this.sh_county_list)
  },

  methods: {
    // 设置默认城市；
    setSelevtProvinceValue() {
      const { cityCode } = this.$route.query;
      cityCode && (this.current_city_code = cityCode)
      this.$set(this.selectVal, 'provinceCode', this.defaultProvinceCode);
      this._provinceChange();
    },
    
    _provinceChange() {
      if (this.selectVal.provinceCode) {
        this.selectRegions.forEach(item => {
          if (item.code === this.selectVal.provinceCode) {
            this.selectCityList = item.city
            this.$set(this.selectVal, 'cityCode', '')
          }
        })
      } else {
        this.selectCityList = []
        this.$set(this.selectVal, 'cityCode', '')
      }
    },
    
    // 设置级联数据
    changeCity() {
      if(this.selectVal.cityCode) {
        this.current_city_code = '';
      } else {
        this.selectVal.countyCode = ''
      }
      this.current_city_code = this.selectVal.cityCode;
      this.changeQuery(true);
    },

    // 设置级联数据
    changeCityForOrg() {
      // 添加会员协会
    },

    // 添加会员协会
    changeCountyForAddCoach() {
      if(this.orgInfo.countyCode) {
        this.sh_county_list.forEach(item => {
          if(item.code === this.orgInfo.countyCode) {
            console.log('item for countyList: ', item)
            this.orgInfo.countyName = item.name;
          }
        })
      }
    },

    // 添加会员协会
    setOrgInfo() {
      this.$set(this.orgInfo, 'provinceCode', this.defaultProvinceCode );
      this.$set(this.orgInfo, 'provinceName', this.defaultProvinceName );
      this.$set(this.orgInfo, 'cityName', this.defaultProvinceName );

    },
  },
}